import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, flatMap, switchMap } from 'rxjs/operators';
import * as fromShared from '../../../shared';
import * as JobActions from './jobs.actions';
import { InternalAdminService } from '../../internal-admin.service';

@Injectable()
export class JobEffects {
    constructor(
        private actions$: Actions,
        private service: InternalAdminService
    ) {}

    get$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(JobActions.getJob),
            switchMap(a =>
                this.service.getJobs().pipe(
                    flatMap(resp => [
                        JobActions.loadJobs({
                            Jobs: JSON.parse(resp)
                        })
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });
}
